import { createSelector } from "@reduxjs/toolkit";
import { type RootState } from "../../store";
import { type Config } from "./types";

function selectConfigSlice(state: RootState) {
	return state.config;
}

export const selectConfigLoaded = createSelector([selectConfigSlice], (configSlice) => configSlice.configLoaded);

export const selectConfigApiBaseUrls = createSelector([selectConfigSlice, selectConfigLoaded], (configSlice, configLoaded) => {
	if (!configLoaded) return null;

	return configSlice.apiBaseUrls as Config["API_BASE_URLS"];
});

export const selectConfigB2C = createSelector([selectConfigSlice, selectConfigLoaded], (configSlice, configLoaded) => {
	if (!configLoaded) return null;
	return configSlice.b2c as Config["B2C"];
});

export const selectConfigUnleash = createSelector([selectConfigSlice, selectConfigLoaded], (configSlice, configLoaded) => {
	if (!configLoaded) return null;

	return configSlice.unleash as Config["UNLEASH"];
});

export const selectConfigApplication = createSelector([selectConfigSlice, selectConfigLoaded], (configSlice, configLoaded) => {
	if (!configLoaded) return null;

	return configSlice.application as Config["APPLICATION"];
});

export const selectConfigMatomo = createSelector([selectConfigSlice, selectConfigLoaded], (configSlice, configLoaded) => {
	if (!configLoaded) return null;

	return configSlice.matomo as Config["MATOMO"];
});

export const selectConfigApplicationId = createSelector([selectConfigSlice, selectConfigLoaded], (configSlice, configLoaded) => {
	if (!configLoaded) return null;

	return configSlice.applicationId as Config["GOS_APPLICATION_ID"];
});
